export enum TipoCredito
{
    LineaCredito = 'Línea de Crédito',
    TarjetaDeCredito = 'Tarjeta de Crédito',
    CreditoEnCuotas = 'Crédito en Cuotas',
    CreditoAutomotriz = 'Crédito Automotriz',
    Hipotecario = 'Hipotecario',
    CreditoComercial = 'Crédito Comercial',
}